import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { SopSicknessLeaveProductPriceFormValues } from "Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/ProductPrice/sopSicknessLeaveProductPriceFormValues";
import { SopSicknessLeaveCoverage } from "Store/interfaces/products/coverage";
import {
  MAX_SUM_DAILY_PAYOUT_AMOUNT,
  MIN_SUM_DAILY_PAYOUT_AMOUNT,
} from "../sopSicknessLeaveConstants";

export const validationSchema =
  (): Yup.ObjectSchema<SopSicknessLeaveProductPriceFormValues> => {
    const { getText } = TextManager;
    return Yup.object()
      .defined()
      .shape({
        dailyPayoutAmount: Yup.number()
          .required(
            getText("sopsicknessleaveform.validation.dailypayoutamount"),
          )
          .max(
            MAX_SUM_DAILY_PAYOUT_AMOUNT,
            getText(
              "sopsicknessleaveform.validation.dailypayoutamount-max-variable",
              {
                variables: {
                  maxSOPDailyPayoutAmount: MAX_SUM_DAILY_PAYOUT_AMOUNT,
                },
              },
            ),
          )
          .min(
            MIN_SUM_DAILY_PAYOUT_AMOUNT,
            getText(
              "sopsicknessleaveform.validation.dailypayoutamount-min-variable",
              {
                variables: {
                  minSOPDailyPayoutAmount: MIN_SUM_DAILY_PAYOUT_AMOUNT,
                },
              },
            ),
          ),
        coverage: Yup.mixed<SopSicknessLeaveCoverage>()
          .oneOf(Object.values(SopSicknessLeaveCoverage))
          .required(),
      });
  };
